import { CONFIG } from "../../appConfig";

const MOBILE_WALLET = "mobileWallet/";

export default {
  /**
   * @desc Get member loyalty card pass for mobile wallets
   * @param {Object} data {endpoint, params}
   * @returns {Object}
   * @memberof services.gma.mobileWallet
   * @example
   * services.gma.mobileWallet.getLoyaltyCard();
   */
  getLoyaltyCard() {
    return {
      method: "GET",
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: MOBILE_WALLET + "getWallet"
    };
  },

  /**
   * @desc Get skip the counter card pass for mobile wallets
   * @param {Object} data {endpoint, params}
   * @returns {Object}
   * @memberof services.gma.mobileWallet
   * @example
   * services.gma.mobileWallet.getSkipTheCounterCard();
   */
  getSkipTheCounterCard() {
    return {
      method: "GET",
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: MOBILE_WALLET + "getSTCWallet"
    };
  }
};
